import React, { useState } from "react";
import { Button, Snackbar } from "@material-ui/core";
import "./CodeBlock.css";

const CodeBlock = ({ code, showCopy = true, showCustomise = false, onCustomise }) => {
    const [copied, setCopied] = useState(false);

    const handleCopy = () => {
        if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(code).then(() => {
                setCopied(true);
            }).catch(() => {
                fallbackCopy();
            });
        } else {
            fallbackCopy();
        }
    };

    const fallbackCopy = () => {
        const textArea = document.createElement("textarea");
        textArea.value = code;
        textArea.style.position = "fixed";
        textArea.style.left = "-9999px";
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();
        try {
            document.execCommand("copy");
            setCopied(true);
        } catch (err) {
            console.error("Failed to copy:", err);
        }
        document.body.removeChild(textArea);
    };

    const handleCloseSnackbar = () => {
        setCopied(false);
    };

    return (
        <div className="code-block-container">
            <div className="code-block-header">
                <span className="code-block-label">Embed Code</span>
                {showCopy && (
                    <Button 
                        variant="outlined" 
                        size="small"
                        className="code-copy-button"
                        onClick={handleCopy}
                    >
                        Copy Code
                    </Button>
                )}
            </div>
            <pre className="code-block-content">
                <code>{code}</code>
            </pre>
            <Snackbar
                open={copied}
                autoHideDuration={2000}
                onClose={handleCloseSnackbar}
                message="Code copied to clipboard!"
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
            />
        </div>
    );
};

export default CodeBlock;
